import type { RouteRecordRaw } from 'vue-router'
import { LOCAL_HUB_SERVICE_ID } from '../config/localServices'

/**
 * Hub ville : /local/{slug} (ex. /local/grande-synthe).
 * Doit rester en dernier dans publicRoutes (après routes statiques et prestation-ville).
 */
export const localCityHubRoute: RouteRecordRaw = {
  path: 'local/:slug',
  name: 'local-city-hub',
  component: () => import('../views/LocalCityView.vue'),
  meta: {
    serviceId: LOCAL_HUB_SERVICE_ID,
    robots: 'index,follow'
  }
}
